import { Component, ElementRef, ViewChild } from '@angular/core';
import { FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { InvestmentFlowService } from '../../../../core/services/Investment-flow/investment-flow.service';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-start-investment-modal',
  imports: [ReactiveFormsModule,CommonModule],
  templateUrl: './start-investment-modal.component.html',
  styleUrl: './start-investment-modal.component.css',
})
export class StartInvestmentModalComponent {

  @ViewChild('phone') phone!: ElementRef<HTMLInputElement>;

   form = new FormGroup({
    phone: new FormControl('', [
      Validators.required,
      Validators.pattern(/^01\d{9}$/)
    ])
  });

  constructor(public flow: InvestmentFlowService) {}


goOtp() {
  if (this.form.invalid) return;

  const localPhone = this.form.value.phone!.trim();   // 010
  const phoneE164 = `+20${localPhone.substring(1)}`;  // +2010

  this.flow.requestOtpAndOpen(phoneE164);
}

 ngAfterViewInit(): void {
  const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);

  if (!isMobile) {
    setTimeout(() => {
      this.phone?.nativeElement.focus();
    }, 300);
  }
}

}


